<div class="aside-wrapper filter-wrapper" *ngIf="filterIsOpened" [@slideInOut]="animateState">
  <ng-content></ng-content>
</div>